<template>
  <Dialog :visible="visible" header="Настройка коммерческого предложения" modal
    :style="{ width: '640px', maxWidth: 'calc(100vw - 2rem)' }"
    :closable="!loading" :closeOnEscape="!loading" @update:visible="$emit('update:visible', $event)" @hide="$emit('hide')">
    <section>
      <h3>Компания / составитель</h3>
      <p v-if="!isB2B">Продавец — ТОО FIABESCO. Ваш профиль будет указан как составитель.</p>
      <template v-if="canUseCompanyLogo">
        <p v-if="logoLoading">Загрузка логотипа...</p>
        <img v-if="logoUrl" :src="logoUrl" alt="Логотип компании для КП" class="logo" />
        <p v-else-if="!logoLoading && !logoError">Логотип не добавлен</p>
        <p v-if="logoError" role="alert">{{ logoError }} <Button label="Повторить" text @click="reload" /></p>
        <p>В КП используется сохранённый логотип. Управление логотипом — в <RouterLink to="/cabinet">профиле</RouterLink>.</p>
      </template>
      <div class="profile-fields">
        <label v-for="field in profileFields" :key="field.key">
          {{ field.label }}
          <InputText :modelValue="auth.user?.[field.key] || ''" readonly class="profile-input" />
        </label>
      </div>
      <small>Данные берутся из профиля. Редактирование для отдельного КП пока недоступно.</small>
    </section>
    <section class="recipient">
      <h3>Получатель</h3>
      <slot v-if="isB2B" />
      <template v-else>
        <p>{{ (auth.user?.fullName || '').trim() || 'Клиент' }}</p>
        <p>{{ auth.user?.phoneNumber || '' }}</p>
        <p>{{ auth.user?.address || '' }}</p>
      </template>
    </section>
    <p v-if="error" role="alert">{{ error }}</p>
    <template #footer>
      <Button label="Отмена" text :disabled="loading" @click="$emit('update:visible', false)" />
      <Button label="Сформировать КП" :loading="loading" :disabled="loading" @click="$emit('generate')" />
    </template>
  </Dialog>
</template>

<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import { useAuthStore } from '@/modules/auth/store/auth.store'
import { useCompanyLogo } from '@/modules/auth/services/useCompanyLogo'

const props = defineProps({ visible: Boolean, loading: Boolean, isB2B: Boolean, error: { type: String, default: '' } })
defineEmits(['update:visible', 'generate', 'hide'])
const auth = useAuthStore()
const profileFields = [
  { key: 'companyName', label: 'Компания' }, { key: 'fullName', label: 'Контактное лицо' },
  { key: 'bin', label: 'БИН' }, { key: 'phoneNumber', label: 'Телефон' },
  { key: 'email', label: 'Email' }, { key: 'address', label: 'Адрес' },
]
const { logoUrl, logoLoading, logoError, reload, canUseCompanyLogo } = useCompanyLogo(
  () => props.visible && auth.user?.hasCompanyLogo ? `${auth.user.id}:${auth.companyLogoVersion}` : '')
</script>

<style scoped>
.logo { width: 200px; max-width: 100%; height: 110px; object-fit: contain; }
.profile-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; margin-bottom: .75rem; }
label { display: flex; flex-direction: column; gap: .4rem; min-width: 0; }
.profile-input { width: 100%; min-width: 0; }
.recipient { margin-top: 1.5rem; }
p { overflow-wrap: anywhere; }
@media (max-width: 480px) { .profile-fields { grid-template-columns: minmax(0, 1fr); } }
</style>
